import React, { useState, useEffect } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGame";
import Calculator from "../../components/FractionsCalculatorNew";
import useTopicQuestions from "../../hooks/useTopicQuestionsNew";
import useSpeech from "../../hooks/useSpeech";
import { Scale } from 'react-scaling';

//NEW CSV STUFF
import Papa from "papaparse";
import extraquestions from '../../assets/Fractions/ExtraQuestions/fractions_extraquestions.csv';

var currentQuestion;

//used for smart allocation -refeed
var refeedQuestions = [];
var repeating = false;
var lastQuestion = "";
var questionCounter = 0;

function GenerateRandom(min, max) {
  return Math.floor(Math.random() * (max - min) + min);
}

//Parameters are information about the number to be generated 
//[0] = min, 
//[1] = max, 
//[2] <=1 no set base, >1 = set base)
//[3]  <1 no max nominator, >= 1 is the max nominator
function GetFraction(param) {
  var bottom, top = 0;
  if (parseInt(param[2]) > 1)
    bottom = parseInt(param[2])
  else
    bottom = Math.floor(param[0] + Math.random() * (param[1] - param[0]));

  top = Math.floor(1 + Math.random() * ((bottom - 1) / 2));

  if (parseInt(param[3]) > 0 && top > parseInt(param[3]))
    top = param[3]

  var frac = [top, bottom];
  return frac;
}

function ShuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}

function AddHTML(string) {
  if (string !== undefined) {
    var newText = string.toString().split(" ");
    for (var i = 0; i < newText.length; i++) {
      if (newText[i].includes("|")){
        var fractionWhole = newText[i].split("|");
        var wholeNum = fractionWhole[0];
        var tempString = fractionWhole[1].split("/");
        console.log("add html");
        console.log(fractionWhole);
        console.log(tempString);
        newText[i] = wholeNum + " <sup>" + tempString[0] + "</sup>&frasl;<sub>" + tempString[1] + "</sub>";
      }
      else{
        if (newText[i].includes('/')) {
          var tempString = newText[i].split("/");
          newText[i] = "<sup>" + tempString[0] + "</sup>&frasl;<sub>" + tempString[1] + "</sub>";
        }
      }
    }
    return newText.join(" ");
  }
  else
    return "<b><u>ERROR empty string</b></u>"
}

function FindFractionLower(question){
  var returnMe = "";

  var splitText = question.split(" ");
  for (let i = 0; i < splitText.length; i++) {
      //split each one if its a fraction to be a fraction object, otherwise its a symbol object
      if (splitText[i].includes("/") && splitText[i].includes("□")){
          returnMe = splitText[i].split("/")[1];
      }
  }
  return returnMe;
}
function ParseDecimalAnswer(correct){
return correct.split(".")[1];
}

function DecimalFirst(correct){
return correct.split(".")[0];
}

function GetImage(image){
return '/qimages/fractions/' + image+".png";
}


var thisQuestion;


export default function Practice({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const [nofeedback, setNoFeedback] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [currQuestion, setCurrentQuestion] = useState([]);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(-10);

  const [qImage, setQImage] = useState("");
  const [qHTML, setQuestionHTML] = useState("");


  //Generates a question from a default question
function GenQuestion(q) {
  let generatedCalculation = [];
  var correctAnswer = "";
  var templateAnswer = "$";
  var questionText;

  if (q.questionline1 != undefined){
    questionText = q.questionline1.replace("<br>", "\n");
  }else{
    questionText = "";
  }

  var questionText2 = "";
  var questionType = "NP";
  var wrong = [];
  var correctAnswer = q.correct_answer;
  var qhtml = "";
  var questionImage = "";
  var qanswers = [];
  var nquestion = q;
  var formattedAnswer = "";
  var templateHTML = "$";

  console.log(q);



  //new question
  if (q.example_question == undefined){

    //fraction
    if (nquestion.topic_key == "frac31S01" || nquestion.topic_key == "frac31S02" || nquestion.topic_key == "frac31S03"){
      //FractionQuestionParser(nquestion.questionline1);
      questionText = AddHTML(questionText);
      //format answer to have the lower fraction
      correctAnswer = q.correct_answer + "/" + FindFractionLower(nquestion.questionline1)
      //add the html to answer
      formattedAnswer = AddHTML(correctAnswer);
      //create the template for the keypad to use
      templateAnswer = "$"+"/"+FindFractionLower(nquestion.questionline1)
      templateHTML = AddHTML(templateAnswer);
  }

  //fraction
  else if (nquestion.topic_key == "frac31S04" || nquestion.topic_key == "frac31S05" || nquestion.topic_key == "frac31S06"){
    questionText = AddHTML(questionText);
    correctAnswer = q.correct_answer;
    formattedAnswer = AddHTML(correctAnswer);
    templateAnswer = "$";
    templateHTML = templateAnswer;
  }

  //decimal
  else if (nquestion.topic_key == "fracY41S01" || nquestion.topic_key == "fracY41S02"){
    questionText = AddHTML(questionText);
    questionType = "MC";
  }
  else if (nquestion.topic_key == "fracY41S03a"){
    questionText = AddHTML(questionText);
    questionType = "MC";

    qhtml = "<div>";
    qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + q.value_for_images + "</b>";
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + q.value_for_images_2 + "</b>"
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + q.value_for_images_3 + "</b>"
    qhtml+= "</div>"
  }
  else if (nquestion.topic_key == "fracY41S03b"){
    questionText = AddHTML(questionText);
    questionType = "MC";
  }
  else if (nquestion.topic_key == "fracY41S04"){
    questionText = AddHTML(questionText);
    questionType = "MC";
    
    //part whole model
      qhtml = "<div>";
      qhtml+= '<img src="' + GetImage("partwhole4") + '"' + "style='position:relative ; right:4% ; z-Index:-1;transform: scale(1.0,1.0); max-height: 400px'" + '></img>';
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:12% ; right:49%'>" + q.value_for_images + "</b>";
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:78% ; right:88%'>" + q.value_for_images_2 + "</b>"
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:78% ; right:49%'>" + q.value_for_images_3 + "</b>"
      qhtml+= "<b style='font-size:30px ;  position:absolute ; top:78% ; right:17%'>" + q.value_for_images_4 + "</b>"
      qhtml+= "</div>"
  }

  else if(nquestion.topic_key == "fracY41S05" || nquestion.topic_key == "fracY41S06"){
    //multiple choice
    questionText = AddHTML(questionText);
    questionType = "MC";
}
else if (nquestion.topic_key == "fracY41S07" || nquestion.topic_key == "fracY41S08"){
  questionText = AddHTML(questionText);
    correctAnswer = q.correct_answer;
    formattedAnswer = correctAnswer;
    if (nquestion.correct_answer.includes(".")){
      templateAnswer = DecimalFirst(nquestion.correct_answer) + ".$";
    }else{
      templateAnswer = "$";
    }
    templateHTML = templateAnswer;
}

//YEAR 2 INCLUDING IMAGE QUESTIONS
else if (nquestion.topic_key == "frac21S01"){
  questionText = AddHTML(questionText);
    correctAnswer = q.correct_answer;
    formattedAnswer = correctAnswer;
    if (nquestion.correct_answer.includes(".")){
      templateAnswer = DecimalFirst(nquestion.correct_answer) + ".$";
    }else{
      templateAnswer = "$";
    }
    templateHTML = templateAnswer;

    qhtml = "<div>";
    qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:4% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:10% ; right:50%'>" + q.value_for_images + "</b>";
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:80%'>" + q.value_for_images_2 + "</b>"
    qhtml+= "<b style='font-size:30px ;  position:absolute ; top:73% ; right:19%'>" + q.value_for_images_3 + "</b>"
    qhtml+= "</div>"
}

else if (nquestion.topic_key == "frac21S02" || nquestion.topic_key == "frac21S03" || nquestion.topic_key == "frac21S05" || nquestion.topic_key == "frac21S07"){
  questionText = AddHTML(questionText);
  questionType = "MC";
  questionImage = GetImage(nquestion.image_type)
}

else if (nquestion.topic_key == "frac21S04" || nquestion.topic_key == "frac21S06" || nquestion.topic_key == "frac21S08" || nquestion.topic_key == "frac21S09"){
    questionText = AddHTML(questionText);
    correctAnswer = q.correct_answer;
    formattedAnswer = AddHTML(correctAnswer);
    templateAnswer = "$";
    templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac21S10"){
  questionText = AddHTML(questionText);
  questionType = "MC";
  questionImage = GetImage(nquestion.image_type)
}
else if (nquestion.topic_key == "frac21S11"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}

else if (nquestion.topic_key == "frac21S12"){
  questionText = AddHTML(questionText);
    correctAnswer = q.correct_answer;
    formattedAnswer = AddHTML(correctAnswer);
    templateAnswer = "$";
    templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac21S13" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
  questionImage = GetImage(nquestion.image_type)
}

else if (nquestion.topic_key == "frac21S14"){
    questionText = AddHTML(questionText);
    correctAnswer = q.correct_answer;
    formattedAnswer = AddHTML(correctAnswer);
    templateAnswer = "$";
    templateHTML = templateAnswer;
}

else if (nquestion.topic_key == "frac21S15"){
  //FractionQuestionParser(nquestion.questionline1);
  questionText = questionText.replace("@", "");
  questionText = AddHTML(questionText);
  //format answer to have the lower fraction
  correctAnswer = q.correct_answer ;
  //add the html to answer
  formattedAnswer = AddHTML(correctAnswer);
  //create the template for the keypad to use
  templateAnswer = "$"+"/"+FindFractionLower(nquestion.questionline1)
  templateHTML = AddHTML(templateAnswer);
}
else if (nquestion.topic_key == "fract54S01"){
  correctAnswer = q.correct_answer;
  templateAnswer = "$";//"+FindFractionLower(nquestion.questionline1)
  templateHTML = templateAnswer;

}
else if (nquestion.topic_key == "fract54S04"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S05"){
  questionText = AddHTML(questionText);
  correctAnswer = nquestion.correct_answer;//.split("/")[0];
  templateAnswer = "$/"+nquestion.correct_answer.split("/")[1];
  templateHTML = templateAnswer;
  
}
else if (nquestion.topic_key == "fract54S06"){
  questionText = AddHTML(nquestion.questionline2);
}
else if (nquestion.topic_key == "fract54S08"){
  questionText = AddHTML(nquestion.questionline2);
}
else if (nquestion.topic_key == "fract54S09"){
  questionText = AddHTML(questionText);
}

else if (nquestion.topic_key == "fract54S10"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S11"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S12"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S13"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S14"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S15"){
  questionText = AddHTML(questionText);
}
else if (nquestion.topic_key == "fract54S16"){
  questionText = AddHTML(questionText);
}
//number line
else if (nquestion.topic_key == "frac63S02"){
  questionText = AddHTML(questionText);

  questionImage = GetImage(nquestion.questionline2.replace(" ",""))
}
else if (nquestion.topic_key == "frac63S03"){
  questionText = AddHTML(nquestion.questionline2);
}
else if (nquestion.topic_key == "frac63S04"){
  questionText = AddHTML(nquestion.questionline2);
}
// NEW QUESTIONS
else if (nquestion.topic_key == "frac63S05" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac63S06" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac63S07" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac63S08" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac63S09" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}

else if (nquestion.topic_key == "frac64S01" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac64S02" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac64S03" ){
  questionText = AddHTML(questionText);
   //questionType = "NP";
}
else if (nquestion.topic_key == "frac64S04" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac64S05" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac64S06" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;

}
else if (nquestion.topic_key == "frac64S07" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac6Sp3S01" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S02" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S03" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S04" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S05" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S06" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S07" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S08" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp3S09" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp4S01" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  templateAnswer = "0.$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac6Sp4S03" ){
  questionText = AddHTML(questionText);
  questionImage = GetImage("HundredSquare-"+nquestion.correct_answer);
  correctAnswer = q.correct_answer ;
  templateAnswer = "$";
  templateHTML = "$%";
}
else if (nquestion.topic_key == "frac6Sp4S04" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac6Sp4S05" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  if (q.correct_answer.includes('.')){
    templateAnswer = "0.$";
    templateHTML = templateAnswer;
  }else{
    templateAnswer = "$";
    templateHTML = "$%";
  }
  
}
else if (nquestion.topic_key == "frac6Sp4S06" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
}
else if (nquestion.topic_key == "frac6Sp4S07" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  if (q.correct_answer.includes('.')){
    templateAnswer = q.correct_answer.split(".")[0]+".$";
    templateHTML = templateAnswer;
  }else{
    templateAnswer = "$";
    templateHTML = templateAnswer;
  }
}
else if (nquestion.topic_key == "frac6Sp4S08" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac6Sp4S09" ){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}

else if (nquestion.topic_key == "frac4Sp03S01" ){
  questionText = AddHTML(questionText);
   questionType = "NP";
}
//part whole model
else if (nquestion.topic_key == "frac4Sp03S03" ){
  questionText = AddHTML(questionText);
   questionType = "MC";
   //set part whole model
   //part whole model
   qhtml = "<div>";
   qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:90% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
   qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:8% ; right:112%'>" + AddHTML(q.value_for_images) + "</b>";
   qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:72% ; right:146%'>" + AddHTML(q.value_for_images_2) + "</b>"
   qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:72% ; right:80%'>" + AddHTML(q.value_for_images_3) + "</b>"
   qhtml+= "</div>"
}
else if (nquestion.topic_key == "frac4Sp03S05" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S06" ){
  questionText = AddHTML(questionText.replace("□ ", "□"));
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S07" ){
  questionText = AddHTML(questionText.replace("| □ ", "□"));
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S08" ){
  questionText = AddHTML(questionText.replace(" | ", "|").replace("□ ", "□"));
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S10" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S11" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S12" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S13" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S14" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}
else if (nquestion.topic_key == "frac4Sp03S15" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
}

else if (nquestion.topic_key == "frac4Sp04S03"){ //place value grid 
  
  let tens = parseInt(nquestion.value_for_images)
  let ones = parseInt(nquestion.value_for_images_2)
  console.log(tens);

  qhtml = '<img src="' + GetImage("pvg") + '"' + "style='position:relative ; right:0% ; z-Index:-1'" + '></img>';
    //then loop through tens
    var rightPosLeft = 90;
    var rightPosMiddle = 73;
    var rightPosRight = 60;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;

    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:65%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Ones</div>'
    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:10%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Tenths</div>'


    qhtml+= "<div>";
    for (let x = 0; x < tens; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>1</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";
    //loop through ones
    var rightPosLeft = 36;
    var rightPosMiddle = 20;
    var rightPosRight = 6;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;


    qhtml+= "<div>";
    for (let x = 0; x < ones; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>0.1</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";
}


else if (nquestion.topic_key == "frac4Sp04S04" ){
  questionText = AddHTML(questionText);
  questionType = "NP";
  qhtml = "<div style='width: 800px; height: 200px; position: fixed; right: 35%; top: 30%'>";
      qhtml += '<img src="' + GetImage("numberlineempty") + '"' + "style='position:relative ; top: -15%; right:0% ; zIndex:-1'" + '></img>';
      qhtml += '<div '+ "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:95%; ;  zIndex:-1'" + '>'+'0</div>'
      qhtml += '<div '+ "style='position:absolute ; font-weight: bold; font-size: 3em; top:-5%; right:0%; ;  zIndex:-1'" + '>'+'1</div>'

      var rightPos = 86.6;
      var column = 1;
      var topPos = 0;
      var rightModifier = 9.45;

      var startNum = q.value_for_images_2;
      var endNum = q.value_for_images_3;

      rightPos = 86.6;
      topPos =  0;
      //then draw the red arrows
      for (let x = 0; x < 10; x++) {
        if (x+1 == nquestion.value_for_images){
          qhtml += '<div '+ "style='color: red; position:absolute ; font-weight: bold; font-size: 3em; top:" + topPos + "%; right:" + rightPos + "%; ;  zIndex:-1'" + '>'+'↓'+'</div>'
        }
        rightPos -= rightModifier;
      }

      qhtml+= "</div>"

}

else if (nquestion.topic_key == "frac4Sp04S09"){ //place value grid 
  
  let tens = parseInt(nquestion.value_for_images)
  let ones = parseInt(nquestion.value_for_images_2)
  let hundredths = parseInt(nquestion.value_for_images_3)
  console.log(tens);

  qhtml = '<img src="' + GetImage("pvg3") + '"' + "style='position:relative ; right:0% ; z-Index:-1'" + '></img>';
    //then loop through tens
    var rightPosLeft = 91;
    var rightPosMiddle = 82;
    var rightPosRight = 73;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;

    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:75%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Ones</div>'
    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:41%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Tenths</div>'
    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:1%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Hundredths</div>'


    qhtml+= "<div>";
    for (let x = 0; x < tens; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>1</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";
    //loop through ones
    var rightPosLeft = 55;
    var rightPosMiddle = 45;
    var rightPosRight = 35;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;


    qhtml+= "<div>";
    for (let x = 0; x < ones; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>0.1</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";

    //loop through hundreds
    var rightPosLeft = 23;
    var rightPosMiddle = 12;
    var rightPosRight = 1;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;


    qhtml+= "<div>";
    for (let x = 0; x < hundredths; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>0.01</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";
}

else if (nquestion.topic_key == "frac3Sp3S03"){
  questionType = "MC";
  questionImage = GetImage(nquestion.image_type.replace(" ", ""))
}

else if (nquestion.topic_key == "frac3Sp3S04" ){
  questionText = AddHTML(questionText);
   //set part whole model
   //part whole model
   qhtml = "<div>";
   qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:90% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
   qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:8% ; right:112%'>" + AddHTML(q.value_for_images) + "</b>";
   qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:72% ; right:146%'>" + AddHTML(q.value_for_images_2) + "</b>"
   qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:72% ; right:80%'>" + AddHTML(q.value_for_images_3) + "</b>"
   qhtml+= "</div>"

   templateAnswer = "$"+"/"+(nquestion.correct_answer.split("/")[1])
   templateHTML = templateAnswer;
}

else if (nquestion.topic_key == "frac3Sp3S08"){
  questionImage = GetImage(nquestion.questionline2.replace(" ", ""))
}

else if (nquestion.topic_key == "frac53S01" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S02" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S03a" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S03b" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S04" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S05" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S06" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S07" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S08" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S09" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S10" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S11" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac53S12" ){
  questionText = AddHTML(questionText);
  questionType = "MC";
}

else if (nquestion.topic_key == "frac5Sp2S01"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp2S02"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp2S03"){

  questionText = AddHTML(questionText + " " + nquestion.questionline2);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp2S04"){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer.replace(/\s/g,"");
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac5Sp2S05"){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer.replace(/\s/g,"");
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac5Sp2S06"){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer.replace(/\s/g,"");
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}

else if (nquestion.topic_key == "frac5Sp3S01"){
  questionText = AddHTML(questionText);

  if (nquestion.incorrect_answer_1 != ""){
    questionType = "MC";
  }else{
    correctAnswer = q.correct_answer.replace(/\s/g,"");
    formattedAnswer = correctAnswer;
    templateAnswer = "$";
    templateHTML = templateAnswer;
  }
  
}
else if (nquestion.topic_key == "frac5Sp3S02"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S03"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S04"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S05"){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;

}
else if (nquestion.topic_key == "frac5Sp3S06"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S07"){
  let tens = parseInt(nquestion.value_for_images)
  let ones = 0;
  let hundredths = parseInt(nquestion.value_for_images_2)
  let THOUSANDTHS = parseInt(nquestion.value_for_images_3)
  console.log(THOUSANDTHS);

  qhtml = '<img src="' + GetImage("pvg4") + '"' + "style='position:relative ; right:0% ; z-Index:-1'" + '></img>';
    //then loop through tens
    var rightPosLeft = 95;
    var rightPosMiddle = 87;
    var rightPosRight = 79;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;

    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:82%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Ones</div>'
    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:56%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Tenths</div>'
    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:25%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Hundredths</div>'
    qhtml += '<div ' + "style='position:absolute ; font-size: 3em; top:5%; right:-1%; transform: scale(0.8,0.8);  zIndex:-1'" + '>Thousandths</div>'

    qhtml+= "<div>";
    for (let x = 0; x < tens; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>1</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";
    //loop through ones
    var rightPosLeft = 67;
    var rightPosMiddle = 60;
    var rightPosRight = 54;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;


    qhtml+= "<div>";
    for (let x = 0; x < ones; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>0.1</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";

    //loop through hundreds
    var rightPosLeft = 41;
    var rightPosMiddle = 33;
    var rightPosRight = 25;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;


    qhtml+= "<div>";
    for (let x = 0; x < hundredths; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>0.01</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";

    //loop through thousandths
    var rightPosLeft = 23;
    var rightPosMiddle = 12;
    var rightPosRight = 1;
    var column = 1;
    var topPos = 30;
    var topModifier = 15;


    qhtml+= "<div>";
    for (let x = 0; x < THOUSANDTHS; x++) {
      //swaps columns
      let rightPos = rightPosLeft;
      if (column == 3){
        rightPos = rightPosRight;
        column = 1;
      }else if (column == 1){
        rightPos = rightPosMiddle;
        column = 2;
      }else{
        column = 3;
      }
       qhtml += '<div ' + "style='position:absolute ; font-size: 2.5em; top:" + topPos + "%; right:" + rightPos + "%; transform: scale(0.8,0.8);  zIndex:-1'" + '>0.001</div>'

      if (column == 1){
        topPos += topModifier;
      }
    }
    qhtml+="</div>";

 //THIS NEEDS A NEW PLACE VALUE CHART OF ONES, TENTHS, HUNDREDTHS, THOUSANDTHS
 questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S08"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S09"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}
else if (nquestion.topic_key == "frac5Sp3S10"){
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer ;
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
}
else if (nquestion.topic_key == "frac5Sp3S11"){
  questionText = AddHTML(questionText);
  questionType = "MC";
}

else if (nquestion.topic_key == "frac5Sp3S12"){
 //PART WHOLE
 questionText = AddHTML(questionText);
 correctAnswer = q.correct_answer ;
 formattedAnswer = correctAnswer;
 templateAnswer = "$";
 templateHTML = templateAnswer;
 correctAnswer = q.correct_answer.replace(/\s/g,"");
  
 //part whole model
 qhtml = "<div>";
 qhtml+= '<img src="' + GetImage("wholemodel") + '"' + "style='position:relative ; right:90% ; zIndex:-1;transform: scale(1.0,1.0)'" + '></img>';
 qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:8% ; right:112%'>" + AddHTML(q.value_for_images) + "</b>";
 qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:72% ; right:146%'>" + AddHTML(q.value_for_images_2) + "</b>"
 qhtml+= "<b style='font-size:30px ;  width: 150px; position:absolute ; top:72% ; right:80%'>" + AddHTML(q.value_for_images_3) + "</b>"
 qhtml+= "</div>"
}

else if (nquestion.topic_key == "frac5Sp3S13"){
  questionText = AddHTML(questionText);
  if (nquestion.incorrect_answer_1 != ""){
     questionType = "MC";
  }else{
    correctAnswer = q.correct_answer.replace(/\s/g,"");
     correctAnswer = q.correct_answer ;
    formattedAnswer = correctAnswer;
    templateAnswer = "$";
    templateHTML = templateAnswer;
  }
}
else if (nquestion.topic_key == "frac5Sp3S14"){
  questionText = AddHTML(questionText);
  if (nquestion.incorrect_answer_1 != ""){
     questionType = "MC";
  }else{
    correctAnswer = q.correct_answer.replace(/\s/g,"");
  formattedAnswer = correctAnswer;
  templateAnswer = "$";
  templateHTML = templateAnswer;
  }
}
else if (nquestion.topic_key == "frac5Sp3S15"){
  questionText = AddHTML(questionText);
  if (nquestion.incorrect_answer_1 != ""){
     questionType = "MC";
  }else{
     correctAnswer = q.correct_answer.replace(/\s/g,"");
    formattedAnswer = correctAnswer;
    templateAnswer = "$";
    templateHTML = templateAnswer;
  }
}

  else if (nquestion.topic_key == "frac12S01"){
        questionText = AddHTML(questionText);
        questionType = "MC";
        questionImage = GetImage(nquestion.image_type.replace(" ", ""));
  }
  else if (nquestion.topic_key == "frac12S04"){
      questionText = AddHTML(questionText);
      correctAnswer = q.correct_answer.replace(/\s/g,"");
      formattedAnswer = correctAnswer;
      templateAnswer = "$";
      templateHTML = templateAnswer;
  }
  else if (nquestion.topic_key == "frac12S05"){
        questionText = AddHTML(questionText);
        questionType = "MC";
        questionImage = GetImage(nquestion.image_type.replace(" ", ""));
  }
  else if (nquestion.topic_key == "frac12S08"){
      questionText = AddHTML(questionText);
      correctAnswer = q.correct_answer.replace(/\s/g,"");
      formattedAnswer = correctAnswer;
      templateAnswer = "$";
      templateHTML = templateAnswer;
  }
             

else{
  questionText = AddHTML(questionText);
  correctAnswer = q.correct_answer;
  templateAnswer = "$";
    templateHTML = templateAnswer;

}




    //return
    if (q.incorrect_answer_1 != "" &&  q.incorrect_answer_1 != undefined){
      console.log("This is multiplechoice");
      //multichoice
      questionType = "MC";
      //add answers
      qanswers.push({correct: true, value: q.correct_answer});
      qanswers.push({correct: false, value: q.incorrect_answer_1});
      if (q.incorrect_answer_2 != "" && q.incorrect_answer_2 != undefined){
        qanswers.push({correct: false, value: q.incorrect_answer_2});
      }
      if (q.incorrect_answer_3 != "" && q.incorrect_answer_3 != undefined){
        qanswers.push({correct: false, value: q.incorrect_answer_3});
      }
      ShuffleArray(qanswers);
    }else{
      if (templateAnswer == null || templateAnswer == ""){
        templateAnswer = "$";
        templateHTML = templateAnswer;
      }
    }



    

    let questionObj = {
      question: questionText,
      questionline2: questionText2,
      answer: formattedAnswer,
      template: templateAnswer,
      templateHTML: templateHTML,
      wronganswers: wrong,
      correct: correctAnswer,
      topic_id: null,
      topic_key: q.topic_key,
      type: questionType,
      version: "new",
      questionHTML: qhtml,
      image: questionImage,
      answers: qanswers
    };

    

    console.log("question object: ", questionObj);
    thisQuestion = questionObj;
    return questionObj;

  }


  var calc = parseInt(q.question_key.toString().replace("FracQ", ""));
  //console.log(calc);
  if (calc <= 4) {
    var frac1, frac2;

    //Simple addition
    if (calc === 1) {
      //Create correct Answer
      frac1 = GetFraction([3, 9, 0, 0]);
      frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);

      correctAnswer = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1];
      templateAnswer = "$/" + frac1[1];

      //Question text =
      generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
    }
    //Simple subtraction
    if (calc === 2) {
      //Create correct Answer
      frac1 = GetFraction([3, 9, 0, 0]);
      frac2 = GetFraction([3, 9, frac1[1], (frac1[1] - frac1[2] - 1)]);

      correctAnswer = parseInt(frac1[0]) + "/" + frac1[1];
      templateAnswer = "$/" + frac1[1];

      //Question text =
      generatedCalculation[0] = (parseInt(frac1[0]) + parseInt(frac2[0])) + "/" + frac1[1] + " - " + frac2[0] + "/" + frac2[1];
    }
    //moderate addition
    if (calc === 3) {
      //Create correct Answer
      frac1 = GetFraction([2, 6, 0, 0]);
      frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);

      correctAnswer = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1];
      templateAnswer = "$/" + frac2[1];

      //Question text =
      generatedCalculation[0] = (frac1[0]) + "/" + frac1[1] + " + " + frac2[0] + "/" + frac2[1];
    }
    //Moderate subtraction
    else if (calc === 4) {

      //Create the question
      frac1 = GetFraction([2, 6, 0, 0]);
      frac2 = GetFraction([3, 9, parseInt(frac1[1]) * 2], (frac1[1] - frac1[2] - 1) * 2);

      //Correct answer is the second fration generated
      correctAnswer = frac2[0] + "/" + frac2[1];
      templateAnswer = "$/" + frac2[1];

      //Question text =
      generatedCalculation[0] = (parseInt(frac1[0]) * 2 + parseInt(frac2[0])) + "/" + frac2[1] + " - " + frac1[0] + "/" + frac1[1];
    }
  }
  //Adding integers to fractions
  else if (calc == 5) {
    var frac1 = GetFraction([2, 9, 0, 0]);
    var number = Math.floor(2 + Math.random() * 7);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " + " + number;

    correctAnswer = number + " " + frac1[0] + "/" + frac1[1];
    templateAnswer = number + " $/" + frac1[1];
  }
  //Subtracting fractions from integers
  else if (calc == 6) {
    var frac1 = GetFraction([2, 9, 0, 0]);
    var number = Math.floor(2 + Math.random() * 7);

    //Question text =
    generatedCalculation[0] = number + " - " + frac1[0] + "/" + frac1[1];

    correctAnswer = (parseInt(number) - 1) + " " + (parseInt(frac1[1]) - parseInt(frac1[0])) + "/" + frac1[1];
    templateAnswer = (parseInt(number) - 1) + " $/" + frac1[1];
  }
  //Equivient fractions
  else if (calc == 7) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    var divider = Math.floor(2 + Math.random() * 3);
    var base = (parseInt(frac1[1]) * divider);
    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " is equivalent to: ?/" + base;

    correctAnswer = (parseInt(frac1[0]) * divider) + "/" + base;
    templateAnswer = "$/" + base;
  }
  //mult(easy)
  if (calc === 8) {
    //Create correct Answer
    frac1 = GetFraction([2, 5, 0, 0]);
    frac2 = GetFraction([2, 5, 0, 0]);

    //Question text =
    generatedCalculation[0] = "1/" + frac1[1] + " x " + "1/" + frac2[1];

    correctAnswer = "1/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    templateAnswer = "1/$";
  }
  //mult(medium)
  if (calc === 9) {
    //Create correct Answer
    frac1 = GetFraction([2, 5, 0, 0]);
    frac2 = GetFraction([4, 7, 0, 0]);
    frac2[0] = Math.floor(1 + Math.random() * (frac2[1] - 1));

    //Question text =
    generatedCalculation[0] = "1/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

    correctAnswer = frac2[0] + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    templateAnswer = frac2[0] + "/$";
  }
  //mult(hard)
  if (calc === 10) {
    //Create correct Answer
    frac1 = GetFraction([4, 7, 0, 0]);
    frac2 = GetFraction([4, 7, 0, 0]);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];

    correctAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    templateAnswer = "$/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
  }
  //Division questions
  if (calc === 11) {
    //generate question
    frac1 = GetFraction([2, 6, 0, 0]);
    frac2 = GetFraction([2, 6, 0, 0]);

    //Question text =
    generatedCalculation[0] = 1 + "/" + frac1[1] + " ÷ " + 1 + "/" + frac2[1];

    correctAnswer = frac2[1] + "/" + frac1[1];
    templateAnswer = frac2[1] + "/$";
  }
  //Division questions
  if (calc === 12) {
    //generate question
    frac1 = GetFraction([2, 6, 0, 1]);
    frac2 = GetFraction([2, 6, 0, 0]);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

    correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
    templateAnswer = "$/" + (frac1[1] * frac2[0]);
  }
  //Division questions
  if (calc === 13) {
    //generate question
    frac1 = GetFraction([2, 6, 0, 1]);
    frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));
    frac2 = GetFraction([3, 6, 0, 0]);
    frac2[0] = Math.floor(2 + Math.random() * (frac2[1] - 2));

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " ÷ " + frac2[0] + "/" + frac2[1];

    correctAnswer = (frac2[1] * frac1[0]) + "/" + (frac1[1] * frac2[0]);
    templateAnswer = "$/" + (frac1[1] * frac2[0]);
  }
  //Multiply an intiger by a fraction
  if (calc === 14) {
    var frac1 = GetFraction([2, 9, 0, 0]);
    var number = Math.floor(2 + Math.random() * 7);

    //Question text =
    generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + number;

    correctAnswer = (number * frac1[0]) + "/" + frac1[1];
    templateAnswer = "$/" + frac1[1];
  }
  //Divide a integer by a fraction
  if (calc === 15) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    var number = Math.floor(2 + Math.random() * 4);

    //Question text =
    generatedCalculation[0] = number + " ÷ " + frac1[0] + "/" + frac1[1];

    correctAnswer = (number * frac1[1]) + "/" + frac1[0];
    templateAnswer = "$/" + frac1[1];
  }
  //Decimals to fractions
  if (calc === 16) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

    //Question text =
    generatedCalculation[0] = "What is " + frac1[0] + "/" + frac1[1] + " as a decimal?";

    correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
    correctAnswer = correctAnswer.toString().substr(0, 4);
    templateAnswer = "0.$";
  }
  //Fractions to percentages
  if (calc === 17) {
    var frac1 = GetFraction([2, 6, 0, 0]);
    frac1[0] = Math.floor(1 + Math.random() * (frac1[1] - 1));

    //Question text =
    generatedCalculation[0] = "What is " + frac1[0] + "/" + frac1[1] + " as a percentage?";

    correctAnswer = parseInt(frac1[0]) / parseInt(frac1[1]);
    correctAnswer = (parseFloat(correctAnswer.toString().substr(0, 4)) * 100.0) + "%";
    templateAnswer = "$%";
  }
  //Decimals to fractions
  if (calc === 18) {
    var frac1 = GetFraction([2, 6, 0, 1]);

    var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
    temp = temp.toString().substr(0, 4);

    //Question text =
    generatedCalculation[0] = "What is " + temp + " as a fraction?"

    correctAnswer = frac1[0] + "/" + frac1[1];
    templateAnswer = frac1[0] + "/$";
  }
  //Decimals to percentages
  if (calc === 19) {
    var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
    generatedCalculation[0] = "What is " + num + " as a fraction?"
    correctAnswer = Math.round(parseFloat(num) * 100) + "%";
    templateAnswer = "$%";
  }
  //Percentages to fractions
  if (calc === 20) {
    var frac1 = GetFraction([2, 6, 0, 1]);

    var temp = parseInt(frac1[0]) / parseInt(frac1[1]);
    temp = Math.round(parseFloat(temp.toString().substr(0, 4)) * 100) + "%";

    //Question text =
    generatedCalculation[0] = "What is " + temp +  " as a fraction?";

    correctAnswer = frac1[0] + "/" + frac1[1];
    templateAnswer = frac1[0] + "/$";
  }
  //Percentages to deciamals
  if (calc === 21) {
    var num = (0.1 + Math.random() * 0.9).toString().substr(0, 4);
    generatedCalculation[0] = "What is " + Math.round(parseFloat(num) * 100) + "% " + "as a decimal?";
    correctAnswer = num;
    templateAnswer = "0.$";
  }
  //Rounding decimals to 1dp
  if (calc === 22) {
    var wholeNum = GenerateRandom(1, 8);
    var dec1Number = Math.round(GenerateRandom(10, 80) / 10) * 10;
    var dec2Number = GenerateRandom(1, 9);
    var num = parseFloat((wholeNum + (dec1Number / 100) + (dec2Number / 100)).toFixed(2));
    /*
    var num = (1.1 + Math.random() * 8.9).toString().substr(0, 4);
    if (num - Math.floor(num) < 0.11)
      num = parseFloat(num) + 0.11;
    if (num.toString()[3] === '0')
      num += 0.01;*/
    generatedCalculation[0] = "Round the following number to 1 decimal place: " + num;

    correctAnswer = Math.round(num * 10) / 10;
    templateAnswer = Math.floor(correctAnswer) + ".$";
  }
  //Rounding decimals to 2dp
  if (calc === 23) {
    /*
    var num = (1.11 + Math.random() * 8.9).toString().substr(0, 5);
    if (num - Math.floor(num) < 0.111)
      num = parseFloat(num) + 0.111;
    */
    var wholeNum = GenerateRandom(1, 8);
    var dec1Number = Math.round(GenerateRandom(10, 80) / 10) * 10;
    var dec2Number = GenerateRandom(1, 8);
    var dec3Number = GenerateRandom(1, 9);
    var num = parseFloat((wholeNum + (dec1Number / 100) + (dec2Number / 100) + (dec3Number / 1000)).toFixed(3));
    console.log(num);
    generatedCalculation[0] = "Round the following number to 2 decimal places: " + num;

    correctAnswer = Math.round(num * 100) / 100;
    templateAnswer = Math.floor(correctAnswer) + ".$";
  }
  //Adding decimals
  if (calc === 24) {
    var dec1 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
    var dec2 = (0.11 + Math.random() * 0.34).toString().substr(0, 4);
    var answer = parseFloat(dec1) + parseFloat(dec2);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec1 + " + " + dec2 + " = ";
    correctAnswer = answer;
    templateAnswer = "0.$";
  }
  //Subracting decimals
  if (calc === 25) {
    var dec1 = (0.61 + Math.random() * 0.34).toString().substr(0, 4);
    var dec2 = (0.11 + Math.random() * 0.3).toString().substr(0, 4);
    var answer = parseFloat(dec1) - parseFloat(dec2);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec1 + " - " + dec2 + " = ";
    correctAnswer = answer;
    templateAnswer = "0.$";
  }
  //Multiplying decimals
  if (calc === 26) {
    let options = [0.2, 0.25, 0.4, 0.5, 0.75];
    var dec1 = options[Math.floor(Math.random() * options.length)];
    var dec2 = (0.4 + Math.random() * 0.3).toString().substr(0, 3);
    var answer = parseFloat(dec1) * parseFloat(dec2);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec1 + " x " + dec2 + " = ";
    correctAnswer = answer;
    templateAnswer = "0.$";
  }
  //Dividing integers by decimals
  if (calc === 27) {
    let options = [0.25, 0.5, 0.2];
    var dec1 = options[Math.floor(Math.random() * options.length)];
    var dec2 = Math.round(1 + Math.random() * 5);
    var answer = parseInt(dec2) / parseFloat(dec1);
    answer = Math.round(answer * 100) / 100;
    generatedCalculation[0] = dec2 + " ÷ " + dec1 + " = ";
    correctAnswer = answer;
    templateAnswer = "$";
  }

  if (calc == 28) {//percentage of a number
    var perc = GenerateRandom(1, 99);
    var number = GenerateRandom(1, 9) * 100;
    var answer = (number / 100) * perc;
    generatedCalculation[0] = "What is " + perc + "% of " + number + " ?";
    correctAnswer = answer;
    templateAnswer = "$";

  }

  if (calc == 29) {//adding mixed numbers
    //Create correct Answer
    //var frac1 = GetFraction([2, 4, 0, 0]);
    //console.log(frac1);
    //var frac2 = GetFraction([frac1[1]*2, frac1[1]*2, 0, 0]);

    //generate fractions
    var num1 = GenerateRandom(1, 9);
    var f1bottom = GenerateRandom(2, 5);
    var f2bottom = f1bottom * 2;
    var f1top = GenerateRandom(1, f1bottom);
    var f2top = GenerateRandom(2, f2bottom);
    var ans;
    var ansInt = num1;

    //calc answer
    if (((f1top * 2) + f2top) == f2bottom) {
      console.log("you right");
      console.log(f2top);
      f2top = f2top-1;
      console.log(f2top);
      ans = (f1top * 2) + f2top;
    }
    else if (((f1top * 2) + f2top) > f2bottom) {
      ansInt = ansInt+1;
      ans = ((f1top * 2) + f2top) - f2bottom;
    }
    else {
      ans = (f1top * 2) + f2top;
    }
    console.log(ans);

    //Question text =
    //generatedCalculation[0] = frac1[0] + "/" + frac1[1] + " x " + frac2[0] + "/" + frac2[1];
    generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " + " + f2top + "/" + f2bottom;
    //correctAnswer = (parseInt(frac1[0]) * parseInt(frac2[0])) + "/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    //templateAnswer = "$/" + (parseInt(frac1[1]) * parseInt(frac2[1]));
    //templateAnswer =  "$"+ansInt.toString()+ f1top.toString()+ f1bottom.toString()+ ""+ f2top.toString()+ f2bottom.toString() + "+";
    correctAnswer = ansInt + " " + ans+"/"+f2bottom;;
    templateAnswer = ansInt + " " + "$/"+f2bottom;
  }

  if (calc == 30) {//subtracting mixed numbers

    //generate fractions
    var num1 = GenerateRandom(1, 9);
    var f1bottom = GenerateRandom(2, 5);
    var f2bottom = f1bottom * 2;
    var f1top = GenerateRandom(1, f1bottom);
    var f2top = GenerateRandom(1, f2bottom);
    var ans;
    var ansInt = num1;

    //calc answer
    if (((f1top * 2) - f2top) == 0) {
      f2top = f2top-1;
      ans = (f1top * 2) - f2top;
    }
    else if (((f1top * 2) - f2top) < 0) {
      ansInt = ansInt-1;
      ans = f2bottom - (f2top - (f1top * 2));
    }
    else {
      ans = (f1top * 2) - f2top;
    }
    console.log(ans);

    generatedCalculation[0] = num1 + " " + f1top + "/" + f1bottom + " - " + f2top + "/" + f2bottom;
    correctAnswer = ansInt + " " + ans+"/"+f2bottom;;
    templateAnswer = ansInt + " " + "$/"+f2bottom;
  }

  //generatedCalculation[0] = AddHTML(generatedCalculation[0]);
  //generatedCalculation[1] = AddHTML(correctAnswer)
  //generatedCalculation[2] = AddHTML(templateAnswer);

  //Creates object to return
  let questionObj = {
    question: AddHTML(generatedCalculation[0]),
    answer: AddHTML(correctAnswer),
    templateHTML: AddHTML(templateAnswer),
    template: templateAnswer,
    correct: correctAnswer,
    type: questionType,
    topic_id: q.topic_id
  };

  console.log("question object: ", questionObj);

  thisQuestion = questionObj;
  return questionObj;
}
  

    //const [questionCounter, setQuesitonCounter] = useState(0);

  const { loadedquestions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });

  var timer = -1;
  if(props.timelimit > 0)
  {
      timer = props.timelimit;
  }
  else
  {
      timer = 60;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else if(waitTime != -10){

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }
   //if question counter is higher than 3 then reset -refeed
    if (questionCounter > 3) {
        questionCounter = 0;
    }

  //Sets the question to a new one
  //Has to use the return keyword in order to set questions, others don't; baffles me as the others don't but it works so...
  function newQuestion() {

         currentQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);

        //get refeed question
        var loop = true;
        if (questionCounter === 2 && refeedQuestions[0] != undefined) {
            repeating = true;
            questionCounter = 0;
            currentQuestion = refeedQuestions[refeedQuestions.length - 1] ;
            loop = false;
        }
        else {
          var loopcount = 10;
            //if current quesiton is same as the previous question then reloop -refeed 
            while (loop && loopcount > 0) {
                if (currentQuestion.question == lastQuestion.toString()) {
                   // console.log("tst: I have looped!");
                    currentQuestion = GenQuestion(questions[Math.floor(Math.random() * questions.length)]);
                }
                else {
                   // console.log("tst: Good to go!");
                    loop = false;
                    break;
                }
                loopcount--;
            }
        }

        if ((currentQuestion.image != "" && currentQuestion.image != undefined)) {
          setQImage(currentQuestion.image);
        }else{
          setQImage("");
        }
        if(currentQuestion.questionHTML != "" && currentQuestion.questionHTML != undefined){
          setQuestionHTML(currentQuestion.questionHTML);
        }else{
          setQuestionHTML("");
        }

        setCurrentQuestion(currentQuestion);


        return currentQuestion;
  }

  //When clicking back or leaving the game result reset the array so it doesn't set the question to one from a previous game. -refeed
   function Reset() {
        refeedQuestions = [];
        questionCounter = 0;
        lastQuestion = "";
        console.log("RESET");
    }

    async function checkResultMultipleChoice(value, callback) {

      //set the current question to the last question -refeed
        questionCounter = questionCounter +1;
        lastQuestion = currQuestion.question;
        console.log("press button");
        console.log(value);
    
        var isCorrect = true;
        if (value) {
          //correct answer
          if (value.correct == true) {
            setCorrectQuestions([...correctQuestions, currQuestion]);
            let multiplier = combo > 0 ? combo + 1 : 1;
            multiplier = multiplier > 5 ? 5 : multiplier;
            setScore(score + multiplier * 10);
    
            if (combo < 99) {
              setCombo(combo + 1);
            }
            if (combo > maxCombo) {
              setMaxCombo(combo);
            }
            //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
            if (repeating) {
                refeedQuestions.pop();
                repeating = false;
            }
    
            let result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: value.value
          };
          setNoFeedback([...nofeedback, result]);
    
            newQuestion();
          }
          //incorrect answer
          else {
              questionCounter = 0;
            isCorrect = false;
            //push question to refeed if user gets it wrong - refeed
            refeedQuestions.push(currQuestion);
    
            setIncorrectQuestions([...incorrectQuestions, currQuestion]);
            if (combo === 0 && score >= 10) {
              setScore(score - 10);
            } else {
              setCombo(0);
            }
            let result = {
              question: currQuestion.question,
              correct: currQuestion.correct,
              incorrect: value.value
            };
    
            setFeedback([...feedback, result]);
            setColouredFeedback(true);
            setWaitTime(2);
          }
    
          //Generates a new question
          //newQuestion();
    
        }
      }

  //Called on click
  async function checkResult(value, callback) {

        //set the current question to the last question -refeed
        questionCounter = questionCounter + 1;
        lastQuestion = currQuestion.question;
        console.log(currQuestion);
        console.log(value);
        
        //trim any garbage
        value = value.replace("<sup>", "");
        value = value.replace("</sup>", "");
        value = value.replace("&frasl;<sub>", "")
        value = value.replace("</sub>", "");

        if (value.includes("0.")){
          value = parseFloat(value);
          currQuestion.correct = parseFloat(currQuestion.correct);
        }
      console.log(value);

      

    var isCorrect = true;
    if (value) {
      //correct answer
      if (currQuestion.correct == value) {
        setCorrectQuestions([...correctQuestions, thisQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }
        //if refeed question is repeating and the user gets the refeed question right, then remove current re feed question from refeed array - refeed
        if (repeating) {
              refeedQuestions.pop();
              repeating = false;
        }
       
        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value
      };
      setNoFeedback([...nofeedback, result]);

      }
      //incorrect answer
      else {
          isCorrect = false;
          questionCounter = 0;
        //push question to refeed if user gets it wrong - refeed
        refeedQuestions.push(currQuestion);

        setIncorrectQuestions([...incorrectQuestions, thisQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value
        };
        setFeedback([...feedback, result]);
      }

      console.log(isCorrect);
      if (callback) {
        await callback(isCorrect, currQuestion.correct).then(() => {
          console.log("Waited then gen");
          setCurrentQuestion(newQuestion());
          console.log(currQuestion.correct.toString());
        });
      } else {
        console.log("Just gen");
        setCurrentQuestion(newQuestion());
        console.log(currQuestion.correct.toString());
      }
    }
  }


  //Set the first question, called until questions are defined
  useEffect(() => {
    console.log(questions);
    if (questions !== undefined && questions.length > 0) {
        lastQuestion = "";
        refeedQuestions = [];
        console.log("Starting Game");
        var sample = newQuestion();
        setCurrentQuestion(sample);
    }
  }, [questions]);

  function AddExtraQuestions(){
    console.log("Adding Extra Questions");
    console.log(extraquestions);
    //import from CSV
    Papa.parse(extraquestions, {
      download: true,
      header: true,
      complete: function (results) {
        let test = 123;
        console.log(test);
        console.log("PROPS");
        console.log(props);
        console.log("Extra Questions:");
        console.log(results.data)
        console.log(loadedquestions);
        console.log(status);
        let addMe = [];
        //check set topics and see if in extra questions
        for (let i = 0; i < props.topicKeys.length; i++) {
          const topicKey = props.topicKeys[i];
          console.log(topicKey);
          for (let x = 0; x < results.data.length; x++) {
            const extraQ = results.data[x];
            //console.log(extraQ);
            if (extraQ.topic_key == topicKey){
              console.log("found you")
              addMe.push(extraQ);
            }
          }
        }

        if (loadedquestions != null){
          //if already loaded
          console.log("add loaded questions");
          for (let i = 0; i < loadedquestions.length; i++) {
            const loadedquesiton = loadedquestions[i];
            addMe.push(loadedquesiton);
          }
      }
        console.log("ALLQUESTIONS:");
        console.log(addMe);
        setQuestions(addMe);
        console.log("done adding extra questions");
      },
    });
  }

  //No clue
  useEffect(() => {
    if (status !== undefined && status === "OK") {
      setLoading(false);
      AddExtraQuestions();
    }
  }, [status]);

  function ComboImage(){
    console.log(props);
    let comboNum = combo;
    if (combo > 4)
        comboNum = 4;
    var imageName = props.gameData.animation_path + "/combo"+comboNum+".gif";
     //return <img src= {{imageName}} style={{position:"relative"}}></img>
     if (combo < 4){
      return <img style={{position: "relative",top:"-300px",right:"-1405px"}} src={require("../../assets/"+imageName)}></img>
     }else{
      return <img style={{position: "relative",top:"-360px",right:"-1405px"}} src={require("../../assets/"+imageName)}></img>
     }
}

function ParseMultipleChoiceAnswer(input){
  var returnMe = "";
  if (input.includes("|")){
    var fractionWhole = input.split("|");
    returnMe = fractionWhole[0] + " "+  AddHTML(fractionWhole[1]);
  }else{
    returnMe = AddHTML(input);
  }
  return returnMe;
}

  
  return (
    <>
      <PracticeGame
        parent={props}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionLimit={questionMax}
        onBack={() => {
        props.onBack();
        Reset();
        }}
        loading={loading}
        feedback={feedback}
        nofeedback={nofeedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
          Reset();
        }}
      >
        <div style={{ backgroundImage: `url(${props.gameBackground})`, backgroundSize: "cover", height: "100%" }} >
          <Scale scaleTo={1920}>
            <Body >

                    {currQuestion !== undefined &&
                     <div style={{ alignItems: "center", position: "absolute", display: "block", right: "65%"}}>
                      {(currQuestion.image != "" && currQuestion.image != undefined && currQuestion.questionHTML == "" && currQuestion.type == "NP") ? (
                        <img src={qImage}></img>
                      ) : (
                          <div></div>
                        )}

                        {currQuestion.questionHTML != "" && currQuestion.type == "NP" ? (
                        <DynamicStyle >
                          <div dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}
                        </div>
              }
              
              <div>
                {currQuestion !== undefined && currQuestion.type == "NP" ? (
                
                <Calculator
                  currentQuestion={currQuestion}
                  onSubmitted={checkResult}
                />

              ) : <div></div>}

              {currQuestion !== undefined && currQuestion.type == "MC" &&
              <div style={{display: "flex", justifyContent: "center"}}>
                <Question2 style={{width: "1000px", position: "absolute", right: "24%", top: "10%"}} dangerouslySetInnerHTML={{ __html: (currQuestion.question) }} ></Question2>
                      {(currQuestion.image != "" && currQuestion.image != undefined && currQuestion.questionHTML == "") ? (
                         <img style={{position: "absolute", right: "44%", top: "30%"}}src={qImage}></img>
                      ) : (
                          <div></div>
                        )}

                        {currQuestion.questionHTML != "" ? (
                        <DynamicStyle >
                          <div style={{position: "fixed", right: "20%", top: "25%"}} dangerouslySetInnerHTML={{ __html: qHTML }}></div>
                        </DynamicStyle>
                      ) :
                        (
                          <div></div>
                        )}

                <div style={{position: "fixed", width: "100%", right: "0%", top: "70%", display: "flex"}}>
                  {showColouredFeedback == false && currQuestion.answers !== undefined &&
                    currQuestion.answers.map(answer => (
                      <Button
                        value={<div dangerouslySetInnerHTML={answer.value} />}
                        style={{ flex: 1, marginInline: "5%" }}
                        onClick={() => checkResultMultipleChoice(answer, true)}
                      >
                        <span>{<div dangerouslySetInnerHTML={{ __html: (ParseMultipleChoiceAnswer(answer.value)) }} />}</span>
                      </Button>
                    ))}

                  {showColouredFeedback == true && currQuestion.answers !== undefined &&
                    currQuestion.answers.map(answer => (
                      <Button
                        value={<div dangerouslySetInnerHTML={answer.value} />}
                        style={{ flex: 1, marginInline: "5%" , ...(answer.correct == true ? {border: "2px solid #19a03f", background: "linear-gradient(0deg,rgba(25, 160, 63, 1) 0%,rgba(43, 196, 86, 1) 100%)"} : {border: "2px solid #ea1d13",background: "linear-gradient(0deg,rgba(234, 29, 19, 1) 0%,rgba(255, 60, 50, 1) 100%)"}) }}
                      >
                        <span>{<div dangerouslySetInnerHTML={{ __html: (ParseMultipleChoiceAnswer(answer.value)) }} />}</span>
                      </Button>
                    ))}
                    </div>
                </div>
              }
              </div>
              <Combo>
                <span style={{ fontSize: "50px" }}>{combo}</span>
                <span style={{ fontSize: "20px" }}>COMBO</span>
              </Combo>
            </Body>
          </Scale>
        </div>
      </PracticeGame>
    </>
  );
}

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url();
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: flex-end;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Container = styled.div`
      width:100%
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
        background: #FFF;
        user-select: none;
        width: 1000px;
        height: 120px;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
      `;

      const Question2 = styled.div`
        background: #FFF;
        user-select: none;
        line-height: 90px;
        font-size: 4em;
        margin: 15px 25px;
        text-align: center;
        font-weight: 600;
        border: none;
        border-radius: 10px;
        padding: 18px;
      `;

const Button = styled.div`
        text-align: center;
        width: 10%;
        height: 150px;
        line-height: 100px;
        font-size: 4em;
        margin: 5px;
        color: #fff;
        user-select: none;
        background: rgb(234, 146, 19);
        background: linear-gradient(
          0deg,
          rgba(234, 146, 19, 1) 0%,
          rgba(255, 186, 32, 1) 100%
        );
        border: 2px solid #e88f12;
        padding: 0.5em;
        box-sizing: border-box;
        border-radius: 0.25em;
        cursor: pointer;
  @media (min-width: 1025px) and (max-width: 1440px) {
          font - size: 2.5em;
      }
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
          margin - bottom: 0;
      }
`;

const DynamicStyle = styled.div`
  text-align: center;
  position: relative;
  width: 100%;
  margin: 20px auto; /* Adds vertical spacing to prevent overlap with buttons */
  display: flex;
  justify-content: center;
  align-items: center;

  .centered {
    position: relative;
    width: 100%;
    text-align: center;
    font-size: 2em;
  }
`;